import validatesFile from 'helpers/validates/file'

import handleDownload from './handleDownload'

const handleOpen = (file) => {
  const isPreview = validatesFile.defineIsPreview(file)

  if (isPreview && file instanceof File) {
    const url = URL.createObjectURL(file)
    return window.open(url, '_blank')
  }

  if (file instanceof File) return handleDownload(file)

  window.open(file?.url, '_blank')
}

export default handleOpen
